import NotEnoughReviews from './NotEnoughReviews';

export default NotEnoughReviews;
